module.exports = __webpack_public_path__ + "img/09.e05e4dc1.jpg";